export function advanceReturnRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_ADVANCE_RETURN_START":           
        case "FETCH_ADVANCE_RETURNS_START":                                 
        case "RECALC_ADVANCE_RETURNS_START":                                 
        case "UPDATE_ADVANCE_RETURN_START":                                 
        case "DELETE_ADVANCE_RETURN_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_ADVANCE_RETURN_FULFILLED":           
        case "FETCH_ADVANCE_RETURNS_FULFILLED":                                 
        case "RECALC_ADVANCE_RETURNS_FULFILLED":                                 
        case "UPDATE_ADVANCE_RETURN_FULFILLED":                                 
        case "DELETE_ADVANCE_RETURN_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_ADVANCE_RETURN_ERROR":
        case "FETCH_ADVANCE_RETURNS_ERROR":
        case "RECALC_ADVANCE_RETURNS_ERROR":
        case "UPDATE_ADVANCE_RETURN_ERROR":
        case "DELETE_ADVANCE_RETURN_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}